import { Component, OnInit } from '@angular/core';
import { ElementFormService } from '../element-form.service';

@Component({
  selector: 'sg2-element-form-controls',
  templateUrl: './element-form-controls.component.html',
  styleUrls: ['./element-form-controls.component.less']
})
export class ElementFormControlsComponent implements OnInit {

  constructor(
    public elementFormService: ElementFormService
  ) { }

  ngOnInit() {
  }

  public cancel(): void {
    this.elementFormService.cancel();
  }

  public submit(): void {
    this.elementFormService.submit();
  }
}
